import { render, staticRenderFns } from "./FooterNavigationMain.vue?vue&type=template&id=aaeb520e"
import script from "./FooterNavigationMain.vue?vue&type=script&lang=js"
export * from "./FooterNavigationMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppLink: require('/vercel/path0/components/shared/AppLink.vue').default})
